<template>
  <div>
    <div class="row col-12">
      <div class="row col-12 q-my-lg">
        <span
          class="text-brand-5 text-weight-bold texto-titulo"
          style="font-size: 17px"
        >
          Lista de Responsáveis
        </span>
      </div>
      <div class="col-12">
        <ListaResponsaveis
          :pt="pt"
          :usuarioPodeEditar="usuarioPodeEditar"
          :usuarioPodeAdicionarUser="usuarioPodeAdicionarUser"
          :usuarioPodeRemoverUser="usuarioPodeRemoverUser"
          @atualizar="atualizar()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, ref, computed } from "@vue/runtime-core";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import ListaResponsaveis from "./ListaResponsaveis.vue";
export default {
  components: { ListaResponsaveis },
  setup() {
    const route = useRoute();
    const store = useStore();
    const router = useRouter();
    const ptId = route.params.ptId;
    const pt = ref(false);
    const data = ref({
      inicio: "",
      final: "",
      emissao: "",
      local: "",
    });

    const buscarDetalhePt = async () => {
      store.dispatch("pdt/hiddenHeader", true);
      const resposta = await store.dispatch("pdt/buscarDetalhePt", { ptId });
      pt.value = resposta.data.resultado.dados;
    };

    const voltar = async () => {
      router.push({ name: "pdt-pt-detalhe" });
    };

    const usuarioPodeEditar = computed(() => {
      if (!pt.value) {
        return false;
      }

      return (
        store.getters["autenticacao/usuarioLogado"].id ===
        pt.value.emissorMatricula
      );
    });

    const usuarioPodeAdicionarUser = computed(() => {
      if (!pt.value) {
        return false;
      }

      const permissoes =
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles || [];

      switch (pt.value.status) {
        case "aguardando_assinaturas":
          return permissoes.includes("pdt-adicionar-user-em-ass");
        case "iniciado":
          return permissoes.includes("pdt-adicionar-user-iniciado");
        default:
          return true;
      }
    });

    const usuarioPodeRemoverUser = computed(() => {
      if (!pt.value) {
        return false;
      }

      const permissoes =
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles || [];

      switch (pt.value.status) {
        case "aguardando_assinaturas":
          return permissoes.includes("pdt-remover-user-em-ass");
        case "iniciado":
          return permissoes.includes("pdt-remover-user-iniciado");
        default:
          return true;
      }
    });

    const atualizar = () => {
      buscarDetalhePt();
    };

    onMounted(buscarDetalhePt);
    return {
      pt,
      ptId,
      data,
      voltar,
      usuarioPodeEditar,
      usuarioPodeAdicionarUser,
      usuarioPodeRemoverUser,
      atualizar,
    };
  },
};
</script>

<style scoped>
.elipse {
  width: 12px;
  height: 12px;
  border-radius: 50%;
}
.cursor {
  cursor: pointer;
}
@media (max-width: 600px) {
  .texto-titulo {
    margin-left: 10px;
    font-size: 14px !important;
  }
}
</style>
